import { render, staticRenderFns } from "./ProfilePermission.vue?vue&type=template&id=7e73c542&scoped=true"
import script from "./ProfilePermission.vue?vue&type=script&lang=js"
export * from "./ProfilePermission.vue?vue&type=script&lang=js"
import style0 from "./ProfilePermission.vue?vue&type=style&index=0&id=7e73c542&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e73c542",
  null
  
)

export default component.exports